export const API_URL = 'https://0o8tyn9cq1.execute-api.ap-northeast-1.amazonaws.com/staging';

export const EDMS_DOMAIN = 'staging.edms.bitriver.jp';

export const cognito = {
  REGION: 'ap-northeast-1',
  USER_POOL_ID: 'ap-northeast-1_TKEOAmE5x',
  APP_CLIENT_ID: '7tqhkfl6h69oe55i7127pjl6fb',
  IDENTITY_POOL_ID: 'ap-northeast-1:685ce01e-349f-4ccd-93e4-c79c48b5890e',
};

export const appSync = {
  url: 'https://2acmjmbr7rdp3f2mczndfczfde.appsync-api.ap-northeast-1.amazonaws.com/graphql',
  region: 'ap-northeast-1',
};

export const zipStrage = {
  AWSS3: {
    bucket: 'edms-zip-staging',
    region: 'ap-northeast-1',
  },
};
